module.exports = __webpack_public_path__ + "static/media/Pawpaw-thumbnail.4add8fa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ToolCard/thumbnails/Pawpaw-thumbnail.png
// module id = 1220
// module chunks = 0